module.exports = __webpack_public_path__ + "img/nysl_logo.fa4c7296.png";